<template>
    <div class="white-box">
        <div>
            <div v-if="storestatus == '1'" class="main-store">MS</div>
            <div v-if="storestatus == '2'" class="sub-store">SS</div>
            <div v-if="storestatus == '3'" class="dept-store">DS</div>
        </div>
        <div>
            <p class="id-txt">{{ StoreId }}</p>
            <p>{{ truncatedBoxText }}</p>
        </div>
        <div class="float-right" v-if="Badge">
            <p class="icon-box-green-request">{{ count }}</p>
        </div>
        <div class="whiteboxdot1">
            <i class="pi pi-circle-fill" style="color: white ; font-size: 0.5rem;"></i>
        </div>
        <div class="whiteboxdot2" v-if="leftdot">
            <i class="pi pi-circle-fill" style="color: white ; font-size: 0.5rem;"></i>
        </div>
        <div class="whiteboxdot3" v-if="rightdot">
            <i class="pi pi-circle-fill" style="color: white ; font-size: 0.5rem;"></i>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from "vue";
export default defineComponent({
    props: {
        count: {
            type: String,
            default: '0'
        },
        boxtext:
        {
            type: String,
            default: ''
        },
        Badge:
        {
            type: Boolean,
            default: false
        },
        StoreId:
        {
            type: String,
            default: ''
        },
        storestatus: {
            type: String,
            default: ''
        },
        storebadge: {
            type: Boolean,
            default: false
        },
        leftdot: {
            type: Boolean,
            default: true
        },
        rightdot: {
            type: Boolean,
            default: true
        },
    },
    setup(props) {
        const truncatedBoxText = computed(() => {
            if (props.boxtext.length <= 15) {
                return props.boxtext;
            } else {
                return props.boxtext.slice(0, 15) + '...';
            }
        });
        return {
            truncatedBoxText,
        };
    },
});
</script>


<style lang="scss" scoped>
.white-box {
    background-color: white;
    width: 150px !important;
    padding: 10px 5px;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: space-around;
    border-radius: 8px;
    position: relative;
}

.main-store {
    font-size: 10px;
    border-radius: 50%;
    background-color: #CDD0FB;
    padding: 5px;
    margin-right: 10px;
}

.sub-store {
    background-color: #fff3cc;
    font-size: 10px;
    border-radius: 50%;
    padding: 5px;
    margin-right: 10px;
}

.dept-store {
    background-color: #f3b7c7;
    font-size: 10px;
    border-radius: 50%;
    padding: 5px;
    margin-right: 10px;
}

.id-txt {
    color: #999999 !important;
    font-size: 10px !important;
    text-align: left;
}

.icon-box-green-request {
    background-color: #61C554;
    color: white !important;
    border-radius: 50%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    width: 20px;
    height: 20px;
    margin-left: 5px;
}

.white-box p {
    white-space: nowrap;
}

.whiteboxdot1 {
    position: absolute;
    right: 50%;
    top: 83% !important;
}

.whiteboxdot2 {
    position: absolute;
    right: 98.35%;
    top: 31% !important;
}

.whiteboxdot3 {
    position: absolute;
    right: -3.25%;
    top: 31% !important;
}
</style>